import React from "react";

const InteractReader = () => {
  return <div>InteractReader</div>;
};

export default InteractReader;
